import styled from "styled-components";

export const BondingDannWrapper = styled.div`


`;